import React from 'react';
import PropTypes from 'prop-types';

const ModalTextContent = ({title, subtitle, text}) => {
	return (
		<div className='modal__text-content'>
			<h3 className='modal__title'>{title}</h3>
			<p className='modal__subtitle'>{subtitle}</p>
			<div className='modal__text' dangerouslySetInnerHTML={{__html: text}}></div>
		</div>
	)
}

export default ModalTextContent;

ModalTextContent.propTypes = {
	title: PropTypes.string,
	subtitle: PropTypes.string,
	text: PropTypes.string,
}

